import React, { useState } from "react";
import Dialog from "material-ui/Dialog";
import {CardTitle,  CardText} from 'material-ui/Card';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import Checkbox from "material-ui/Checkbox";

const CriteriaDialog = ({ onClose, onSave, open, criteria, questions }) => {
  const [checked, setChecked] = useState(criteria || []);
  const handleCheck = (e, id) => {
    let checks;
    if (e.target.checked) {
      checks = [...checked, id];
    } else {
      checks = checked.filter(i => i !== id);
    }
    setChecked(checks);
  };

  return (
    <Dialog
      title="Edit Criteria"
      open={open}
      autoScrollBodyContent
      actions={[
        <FlatButton label="Cancel" onClick={onClose} />,
        <RaisedButton primary label="Save" onClick={() => onSave(checked)} />
      ]}
    >
      {questions.length === 1 ? (
        <CardText>Check all answers that would satisfy this criteria.</CardText>
      ) : (
        <CardText>
          Check all answers that would satisfy this criteria. In the case of
          criteria that span multiple questions, answering with any acceptable
          answer will be considered as passing the criteria.
        </CardText>
      )}
      {questions.map(q => {
        return (
          <div key={`qd-q-${q.id}`}>
            <CardTitle
              style={{ paddingBottom: 0 }}
              titleStyle={{ fontSize: 16, fontWeight: 500 }}
              title={q.title.replace(/<.*?>/gm, '')}
            />
            <CardText>
              {q.answers.map(a => {
                return (
                  <Checkbox
                    key={`qd-a-${a.id}`}
                    checked={checked.indexOf(a.id) !== -1}
                    onClick={(e, isChecked) => handleCheck(e, a.id)}
                    label={a.title}
                  />
                );
              })}
            </CardText>
          </div>
        );
      })}
    </Dialog>
  );
};

export default CriteriaDialog;
